export const navigationByRole = {
  admin: [
    { path: '/', label: 'Dashboard', icon: 'dashboard', section: 'Overview' },
    { path: '/profile', label: 'My Profile', icon: 'members', section: 'Overview' },

    { path: '/members', label: 'Members', icon: 'members', section: 'Members' },
    { path: '/pending-admissions', label: 'Pending Admissions', icon: 'claims', section: 'Members' },
    { path: '/deceased-members', label: 'Deceased Members', icon: 'deceased', section: 'Members' },

    { path: '/payments', label: 'Payments', icon: 'payments', section: 'Finance & Claims' },
    { path: '/payout-register', label: 'Payout Register', icon: 'beneficiaries', section: 'Finance & Claims' },
    { path: '/claims', label: 'Claims', icon: 'claims', section: 'Finance & Claims' },
    { path: '/crdb-requests', label: 'CRDB Requests', icon: 'payments', section: 'Finance & Claims' },

    { path: '/reports', label: 'Reports', icon: 'reports', section: 'Reports' },
    { path: '/health-insurance', label: 'Health Insurance', icon: 'beneficiaries', section: 'Reports' },
    { path: '/audit-trail', label: 'Audit Trail', icon: 'reports', section: 'Reports' },

    { path: '/staff', label: 'Staff & Approvers', icon: 'users', section: 'Administration' },
    { path: '/error-logs', label: 'Error Logs', icon: 'reports', section: 'Administration' },
    { path: '/fee-config', label: 'Fee Settings', icon: 'settings', section: 'Administration' },
    { path: '/system-settings', label: 'System Settings', icon: 'system', section: 'Administration' },
  ],
  finance: [
    { path: '/', label: 'Dashboard', icon: 'dashboard' },
    { path: '/profile', label: 'My Profile', icon: 'members' },
    { path: '/payments', label: 'Payments', icon: 'payments' },
    { path: '/claims', label: 'Claims', icon: 'claims' },
    { path: '/reports', label: 'Reports', icon: 'reports' },
  ],
  board: [
    { path: '/', label: 'Dashboard', icon: 'dashboard' },
    { path: '/profile', label: 'My Profile', icon: 'members' },
    { path: '/claims', label: 'Claims', icon: 'claims' },
  ],
  member: [
    { path: '/', label: 'Dashboard', icon: 'dashboard' },
    { path: '/profile', label: 'My Profile', icon: 'members' },
    { path: '/beneficiaries', label: 'Beneficiaries', icon: 'beneficiaries' },
    { path: '/payments', label: 'Payments', icon: 'payments' },
    { path: '/receipts', label: 'Receipts', icon: 'receipt' },
  ],
};

// Maps each admin nav path to the permission group(s) (see
// PermissionsController::CATALOG) that should also unlock it for a user
// whose base role wouldn't normally show it — lets admin grant a single
// capability (e.g. "claims") to a finance/board/member user without
// promoting them to full admin.
const PATH_PERMISSIONS = {
  '/members': ['members'],
  '/pending-admissions': ['pending_admissions'],
  '/deceased-members': ['members'],
  '/payout-register': ['claims'],
  '/payments': ['payments', 'bank_reconciliation'],
  '/claims': ['claims'],
  '/reports': ['reports'],
  '/health-insurance': ['reports'],
  '/staff': ['staff'],
  '/audit-trail': ['audit_trail'],
  '/crdb-requests': ['crdb_requests'],
  '/error-logs': ['error_logs'],
  '/fee-config': ['fee_config', 'payment_methods'],
  '/system-settings': ['system_settings', 'zones'],
};

export function getNavigationForRole(role, permissions = []) {
  const base = navigationByRole[role] || navigationByRole.member;
  if (!permissions || permissions.length === 0) {
    return base;
  }

  const extra = navigationByRole.admin.filter((item) => {
    if (base.some((b) => b.path === item.path)) return false;
    const required = PATH_PERMISSIONS[item.path];
    return required && required.some((key) => permissions.includes(key));
  });

  return extra.length > 0 ? [...base, ...extra] : base;
}
